const constForm = {
  step: 'lp',
  render: 'false',
  referer: 14,
  lp_type: 'chat'
}

export default {
  data: function () {
    return {
      constForm
    }
  },
  computed: {
    constApp: function () {
      const homeUrl = process.env.NODE_ENV === 'production'
        ? 'https://www.daini-agent.jp'
        : 'https://local.daini.s-agent.jp'
      return {
        route: {
          home: homeUrl
        }
      }
    },
    constApi: function () {
      const requestUrl = process.env.NODE_ENV === 'production'
        ? '/account/register'
        : 'https://local.daini.s-agent.jp/account/register'
      return {
        isSend: process.env.NODE_ENV === 'production',
        url: {
          request: requestUrl,
          complete: '/account/register'
        },
        badRequestMessage: 'エラーが発生しました。お手数ですがページをリロードして再度お試しください。'
      }
    },
    kairosApi: function () {
      const url = new URL(window.location.href)
      const red = `${url.origin.replace(/\/$/, '')}/account/register/thanks`
      const redError = `${url.origin.replace(/\/$/, '')}/account/customers/kairos-error`
      return {
        url: {
          action: 'https://form.k3r.jp/ag2nd/00002',
          red: red,
          redError: redError
        },
        form: {
          stopFlg: 0,
          apiKey: 'a67f185257b9deb42a4fab524568cd2f52326b58',
          tag: '新規会員登録'
        }
      }
    },
    aeApi: function () {
      return {
        isSend: process.env.NODE_ENV === 'production',
        url: {
          action: 'https://link.daini-agent.jp/l/1126553/2026-07-18/8rn6jr'
        },
        storageKey: {
          gclid: 'gclid'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ConstMixin.js